import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import ReactEcharts from 'echarts-for-react'
import { setSelectedSector, setSelectedCountry, resetScrollCountry, setActiveSoeDataType, setActiveSoePane } from '../../../actions'
import { getSectorChart, getSectorGraph, getMarketCapChart, getMaturityChart, getCreditQualityChart, getAssetClassChart, getCountryChart, getRegionChart, getCountryGraph, getUniqueCountries } from '../charts.js'
import SoeRow from '../Soe/SoeRow'
import './Exposures.css'
import i18n from '../../../i18n'
import CompText from '../Compliance/CompText'
import Select from 'react-select'
import { RenderAggandExposureHistory } from '../Components/Spinner'
import ProgressBar from '../Components/ProgressBar'
import { SomethingWentWrong } from '../Components/ErrorHandle'

const customStyles = {
  control: base => ({
    ...base,
    borderRadius: 0,
    border: '1px solid #050139', // default border color
    boxShadow: 'none'
  }),
  option: provided => ({
    ...provided,
    color: '#5b6770',
    fontSize: 14,
    borderRadius: 0,
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: '#050139',
      color: 'white'
    },
    overflowY: 'hidden'
  }),
  menu: base => ({
    ...base,
    borderRadius: 0
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1
    const transition = 'opacity 100ms'
    return { ...provided, opacity, transition }
  },
  dropdownIndicator: base => ({
    ...base,
    color: '#050139'
  })
}
class Exposures extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showMoreChars: false,
      chartType: { value: 'SOE', label: 'SOE' },
      SOECatType1: { value: 'SOE', label: 'SOE' },
      SOECatType2: { value: 'SOE', label: 'SOE' }
    }
  }
  handleChartTypeChange = chartType => {
    this.setState({ chartType: chartType })
  }

  setActiveSoePane(val) {
    this.props.setActiveSoePane(val)
  }

  scrollCountry() {
    if (this.props.scrollCountry) {
      const elem = document.getElementById('country')
      elem.scrollIntoView()
      this.props.resetScrollCountry()
    }
    return true
  }

  // asOfDate(name, data) {
  //     const fund = data[0];
  //     const value = fund[name][fund[name].length - 1];
  //     return new Date(value.date).toLocaleString().split(',')[0].split(' ')[0];
  // }
  asOfDate(name, data) {
    const fund = data[0]
    const value = fund[name] && fund[name][fund[name].length - 1] ? fund[name][fund[name].length - 1] : undefined
    if (value && value.date) {
      return new Date(value.date).toLocaleString().split(',')[0].split(' ')[0]
    } else {
      return new Date().toLocaleString().split(',')[0].split(' ')[0] // returns the current date
    }
  }

  getAllIndexes(arr, val) {
    var indexes = [],
      i = -1
    while ((i = arr.indexOf(val, i + 1)) !== -1) {
      indexes.push(i)
    }
    return indexes
  }

  consolidatedCountry(data) {
    const countries = data.forEach(fund => {
      let topkeys = ''
      let topvalues = ''
      if (fund.countryExposures) {
        let keys = fund.countryExposures[fund.countryExposures.length - 1].keys
        let values = fund.countryExposures[fund.countryExposures.length - 1].values
        const ix = keys.map((x, i) => i)

        ix.sort((a, b) => values[b] - values[a])
        values = ix.map(x => values[x])
        keys = ix.map(x => keys[x])

        topkeys = keys.slice(0, 10)
        topvalues = values.slice(0, 10)
        if (values.length > 10) {
          const othervalues = values.slice(10, values.length)
          const total = othervalues.reduce((acc, ele) => acc + ele, 0)
          topkeys.push('Other')
          topvalues.push(total)
        }

        fund.countryExposures[fund.countryExposures.length - 1].keys = topkeys
        fund.countryExposures[fund.countryExposures.length - 1].values = topvalues
      }
    })
    return data
  }

  getSubTotals(array) {
    let sum = 0
    for (let i = 0; i < array.length; i++) {
      sum += array[i]
    }
    return sum
  }

  getSortedKeys(data, type) {
    let xDataCloned = JSON.parse(JSON.stringify(data))
    let xData = this.getSortedData(xDataCloned)
    let keys = xData.keys
    if (type === 'Sector') {
      console.log()
      return keys
    } else if (type === 'Country') {
      if (keys.length <= 10) {
        return keys
      } else {
        let y = keys.slice(0, 10)
        y.push('Other')
        return y
      }
    }
  }

  getSortedData(data) {
    //simple desc sort on values array
    let keys = [...data.keys]
    let values = [...data.values]
    const ix = keys.map((x, i) => i)
    ix.sort((a, b) => values[b] - values[a])
    values = ix.map(x => values[x])
    keys = ix.map(x => keys[x])
    data.keys = keys
    data.values = values
    return data
  }

  getTableData(data2) {
    const { data, activeSoeDataType } = this.props

    //get keys that will be used on Summary tab
    let sumKeys = []
    let topKeys = []
    let otherKeys = []
    const soeData = data.filter(x => x.countryExposuresSOESummary !== null)

    if (activeSoeDataType === 'Country') {
      sumKeys = this.getSortedData(soeData[0].countrySOESubTotals[soeData[0].countrySOESubTotals.length - 1]).keys
      //keep summary keys & divide SOE/NON SOE data if > 10
      topKeys = sumKeys.slice(0, 10)
      if (sumKeys.length > 10) {
        otherKeys = sumKeys.slice(10, sumKeys.length)
      }

      //divide incoming data if greater than 10 into top 10 & other -  order s/b same as summary tab
      let keys = [...data2.keys]
      let values = [...data2.values]
      let founds = []
      let oValues = []
      let oKeys = []
      let tValues = []
      let tKeys = []
      keys.forEach((x, i) => {
        const found = topKeys.indexOf(x);
        if (found !== -1) {
          founds.push(i);
          tValues.push(values[i]);
          tKeys.push(keys[i]);
        } else {
          oValues.push(values[i]);
          oKeys.push(keys[i]);
        }
      });
      

      const oTotal = oValues.reduce((acc, ele) => acc + ele, 0)
      tKeys.push('Other')
      tValues.push(oTotal)
      data2.keys = tKeys
      data2.values = tValues
      return data2
    } else if (activeSoeDataType === 'Sector') {
      sumKeys = this.getSortedData(soeData[0].sectorSOESubTotals[soeData[0].sectorSOESubTotals.length - 1]).keys
      return data2
    }
  }

  getLevelData(data, constituent, level, type) {
    const { activeSoeDataType, activeSoePane } = this.props

    let filteredData = data.map((fund, i) => {
      let xData = []
      if (activeSoeDataType === 'Sector') {
        if (activeSoePane === 'Summary') {
          //copy data to avoid mutating original Other will duplicate
          if (type === 'SUM') {
            let yxData = fund.sectorSOESubTotals[fund.countrySOESubTotals.length - 1]
            let xDataCloned = JSON.parse(JSON.stringify(yxData))
            xData = this.getTableData(xDataCloned)
          } else if (type === 'SOE') {
            let yxData = fund.sectorExposuresSOE[fund.sectorExposuresSOE.length - 1]
            let xDataCloned = JSON.parse(JSON.stringify(yxData))
            xData = this.getTableData(xDataCloned)
          } else if (type === 'NONSOE') {
            let yxData = fund.sectorExposuresNonSOE[fund.sectorExposuresNonSOE.length - 1]
            let xDataCloned = JSON.parse(JSON.stringify(yxData))
            xData = this.getTableData(xDataCloned)
          }
        } else if (activeSoePane === 'Details-SOE') {
          let yxData = fund.sectorExposuresSOE[fund.sectorExposuresSOE.length - 1]
          let xDataCloned = JSON.parse(JSON.stringify(yxData))
          xData = this.getTableData(xDataCloned)
        } else if (activeSoePane === 'Details-NonSOE') {
          let yxData = fund.sectorExposuresNonSOE[fund.sectorExposuresNonSOE.length - 1]
          let xDataCloned = JSON.parse(JSON.stringify(yxData))
          xData = this.getTableData(xDataCloned)
        }
      } // sector type
      else if (activeSoeDataType === 'Country') {
        if (activeSoePane === 'Summary') {
          if (type === 'SUM') {
            let yxData = fund.countrySOESubTotals[fund.countrySOESubTotals.length - 1]
            let xDataCloned = JSON.parse(JSON.stringify(yxData))
            xData = this.getTableData(xDataCloned)
          } else if (type === 'SOE') {
            let yxData = fund.countryExposuresSOE[fund.countryExposuresSOE.length - 1]
            let xDataCloned = JSON.parse(JSON.stringify(yxData))
            xData = this.getTableData(xDataCloned)
          } else if (type === 'NONSOE') {
            let yxData = fund.countryExposuresNonSOE[fund.countryExposuresNonSOE.length - 1]
            let xDataCloned = JSON.parse(JSON.stringify(yxData))
            xData = this.getTableData(xDataCloned)
          }
        } else if (activeSoePane === 'Details-SOE') {
          let yxData = fund.countryExposuresSOE[fund.countryExposuresSOE.length - 1]
          let xDataCloned = JSON.parse(JSON.stringify(yxData))
          xData = this.getTableData(xDataCloned)
        } else if (activeSoePane === 'Details-NonSOE') {
          let yxData = fund.countryExposuresNonSOE[fund.countryExposuresNonSOE.length - 1]
          let xDataCloned = JSON.parse(JSON.stringify(yxData))
          xData = this.getTableData(xDataCloned)
        }
      } //country type

      var indexes = this.getAllIndexes(xData.keys, constituent)
      let indexData = ''
      if (activeSoePane === 'Summary') {
        indexData = xData.values[indexes[0]]
      } else if (activeSoePane === 'Details-NonSOE') {
        if (type === 'NONSOE') indexData = xData.values[indexes[0]]
        else indexData = this.getSubTotals(xData.values)
      } else if (activeSoePane === 'Details-SOE') {
        if (type === 'SOE') indexData = xData.values[indexes[0]]
        else indexData = this.getSubTotals(xData.values)
      } else indexData = xData.values[indexes[0]]

      return indexData
    })
    return filteredData
  }

  renderSoeTableHeader() {
    const { data, activeSoeDataType } = this.props

    const soeData = data.filter(x => x.countryExposuresSOESummary !== null)
    const tickerList = data
      .filter(x => x.countryExposuresSOESummary !== null)
      .map(fund => {
        if (fund.type === 'BMK') {
          return (
            <th key={fund.ticker} className='textCenter'>
              {fund.ticker}
            </th>
          )
        } else {
          return (
            <th key={fund.ticker} className='textCenter'>
              {fund.fundPageURL && (
                <a className='tickerLinkFC' href={fund.fundPageURL} target='_new'>
                  {fund.ticker}
                </a>
              )}
              {!fund.fundPageURL && (
                <a className='tickerLinkFC' href={fund.msUrl} target='_new'>
                  {fund.ticker}
                </a>
              )}
            </th>
          )
        }
      })

    return (
      <Fragment>
        <tr>
          {activeSoeDataType === 'Sector' && (
            <Fragment>
              <th colSpan='14' className='textLeft'>
                {i18n.t('State-Ownership & Sector Breakdown (% Weight) ')} {i18n.t('as of')} {this.asOfDate('sectorSOESubTotals', soeData)}&nbsp;&nbsp;&nbsp;
              </th>
            </Fragment>
          )}
          {activeSoeDataType === 'Country' && (
            <Fragment>
              <th colSpan='14' className='textLeft'>
                {i18n.t('State-Ownership & Country Breakdown (% Weight) ')} {i18n.t('as of')} {this.asOfDate('countrySOESubTotals', soeData)}&nbsp;&nbsp;&nbsp;
              </th>
            </Fragment>
          )}
        </tr>
        <tr>
          <th className='textLeft'>{activeSoeDataType}</th>
          <th className='textLeft'>{'State-Ownership '}</th>
          {tickerList}
        </tr>
      </Fragment>
    )
  }

  renderSoeTableDetails() {
    const { data, activeSoeDataType, activeSoePane } = this.props

    const soeData = data.filter(x => x.countryExposuresSOESummary !== null)
    const tickers = data.filter(x => x.countryExposuresSOESummary !== null).map(a => a.ticker)

    let allConstituentKeys = []
    let magicArrayToMap = []

    // get top country keys for first selected fund
    let summaryCountryConstituent = this.getSortedKeys(soeData[0].countrySOESubTotals[soeData[0].countrySOESubTotals.length - 1], activeSoeDataType)
    let summarySectorConstituent = this.getSortedKeys(soeData[0].sectorSOESubTotals[soeData[0].sectorSOESubTotals.length - 1], activeSoeDataType)

    if (activeSoeDataType === 'Country') {
      allConstituentKeys = [...summaryCountryConstituent]
    } else {
      allConstituentKeys = [...summarySectorConstituent]
    }

    if (activeSoePane === 'Summary') {
      allConstituentKeys.forEach(x => {
        let m0 = {}
        m0.key = x + '-' + 0
        m0.detailType = '-'
        m0.displayName = x
        m0.level = '1'
        m0.style = 'blue'
        m0.value = this.getLevelData(soeData, x, 'Summary', 'SUM')
        magicArrayToMap.push(m0)

        let m1 = {}
        m0.key = x + 'SOE' + 1
        m1.detailType = 'SOE'
        m1.displayName = x
        m1.level = '2'
        m1.style = 'white'
        m1.value = this.getLevelData(soeData, x, 'Details-SOE', 'SOE')
        magicArrayToMap.push(m1)

        let m2 = {}
        m0.key = x + 'non-SOE' + 2
        m2.detailType = 'non-SOE'
        m2.displayName = x
        m2.level = '2'
        m2.style = 'white'
        m2.value = this.getLevelData(soeData, x, 'Details-NonSOE', 'NONSOE')
        magicArrayToMap.push(m2)
      })
    }
    if (activeSoePane === 'Details-SOE') {
      allConstituentKeys.forEach(x => {
        let m1 = {}
        m1.detailType = 'SOE'
        m1.displayName = x
        m1.level = '2'
        m1.style = 'white'
        m1.value = this.getLevelData(soeData, x, 'Details-SOE', 'SOE')
        magicArrayToMap.push(m1)
      })
      //add summary in front of array
      let m0 = {}
      m0.key = 'Summary' + '-' + 0
      m0.detailType = 'SOE'
      m0.displayName = '-'
      m0.level = '1'
      m0.style = 'blue'
      m0.value = this.getLevelData(soeData, 'Summary', 'Summary', 'SUM')
      magicArrayToMap.unshift(m0)
    }

    if (activeSoePane === 'Details-NonSOE') {
      allConstituentKeys.forEach(x => {
        let m2 = {}
        m2.detailType = 'Non-SOE'
        m2.displayName = x
        m2.level = '2'
        m2.style = 'white'
        m2.value = this.getLevelData(soeData, x, 'Details-NonSOE', 'NONSOE')
        magicArrayToMap.push(m2)
      })
      //add summary in front of array
      let m0 = {}
      m0.key = 'Summary' + '-' + 0
      m0.detailType = 'NON-SOE'
      m0.displayName = '-'
      m0.level = '1'
      m0.style = 'blue'
      m0.value = this.getLevelData(soeData, 'Summary', 'Summary', 'SUM')
      magicArrayToMap.unshift(m0)
    }

    return magicArrayToMap.map(metric => {
      return <SoeRow key={metric.key} style={metric.style} displayName={metric.displayName} values={metric.value} filter={activeSoePane} tickers={tickers} type={metric.type} detailType={metric.detailType} />
    })
  }


  render() {
    const { data, selectedCountry, selectedSector, activeSoePane, setActiveSoeDataType, loadingCatchAll, hasBlendedData, errorCatchAll } = this.props

    const sectorData = data.filter(x => x.sectorExposures && x.sectorExposures.length > 0)
    const regionData = data.filter(x => x.regionExposures && x.regionExposures.length > 0)
    const country = data.filter(x => x.countryExposures && x.countryExposures.length > 0)
    const countryData = this.consolidatedCountry(country)
    const creditData = data.filter(x => x.creditQualityExposures && x.creditQualityExposures.length > 0)
    const matureData = data.filter(x => x.maturityExposures && x.maturityExposures.length > 0)
    
    // const matureData = data.filter(x => x.maturityExposures !== null)
    const assetData = []
    const marketData = data.filter(x => x.marketCapExposures && x.marketCapExposures.length > 0)
    // const funds = data.filter((x) => x.multifactorTilts !== null);
    // const EqIncFund = data.filter((x) => x.assetClass !== 'Fixed Income');
    const soeData = data.filter(x => x.countryExposuresSOESummary && x.countryExposuresSOESummary.length > 0)

    const dataArrays = [sectorData, regionData, country, creditData, matureData, marketData];
    const hasExposureData = dataArrays.some(data => data.length > 0);


  //if we are still fetching data and current loaded data has factors
  const ProgressBarIfGettingBlendedData = () => {
    return (
      (loadingCatchAll && hasExposureData && hasBlendedData) && (
        <div>
          <ProgressBar message={i18n.t('loading_blended')}/>
          <div style={{ marginBottom: '65px' }} />
        </div>
      )
    );
  };

    //if endpoint breaks
    if (errorCatchAll) {
      return(
        <div>
          <SomethingWentWrong />
          <CompText pane='Exposures' />
        </div>
      )
    }   

    //if we are still fetching data and current loaded data has no exposures
    if (loadingCatchAll && !hasExposureData) {
      return(
        <div>
          <ProgressBar title={'FUND EXPOSURES'} message={i18n.t('loading_exposures')} />
          <CompText pane='Exposures' />
        </div>
      )
    } 

    //if we are done fetching data and current loaded data has no exposures
    if (!loadingCatchAll && !hasExposureData) {
      return (
        <div>
          <div className='noData'>{i18n.t('no-data')} </div>
          <div style={{ marginBottom: '65px' }} />
          <CompText pane='Exposures' />
        </div>
      )
    }    

    return (
      <div className='fund-char-exposures'>
        <ProgressBarIfGettingBlendedData />
        {sectorData.length > 0 && (
          <div>
            <div className='chartHeader'>
              {i18n.t('SECTOR EXPOSURE (% WEIGHT)')} {i18n.t('as of')} {this.asOfDate('sectorExposures', sectorData)}&nbsp;&nbsp;&nbsp;
              <span style={{ fontStyle: 'italic' }}>{i18n.t('select a sector to view historical data')}</span>
            </div>
            <div className='row' style={{ marginBottom: '20px' }}></div>
            <div className='chartContainer'>
              <ReactEcharts 
                onEvents={{ click: this.props.setSelectedSector }} 
                option={getSectorChart(sectorData)} 
                theme='default' style={{ height: 400 }} />
            </div>
            {this.props.selectedSector !== '' && (
              <div className='subchartContainer'>
                <RenderAggandExposureHistory />
                <ReactEcharts option={getSectorGraph(selectedSector, sectorData)} theme='default' style={{ height: 300 }} />
              </div>
            )}
            <div className='subjectToChange'>
              {i18n.t('subject to change')} {i18n.t('sectors-gics')} (GICS&reg;).
            </div>
          </div>
        )}

        {regionData.length > 0 && (
          <div>
            <div className='chartHeader'>
              {i18n.t('REGION EXPOSURE (% WEIGHT)')} {i18n.t('as of')} {this.asOfDate('regionExposures', regionData)}&nbsp;&nbsp;&nbsp;
              <span style={{ fontStyle: 'italic' }}></span>
            </div>
            <div className='chartContainer'>
              <ReactEcharts option={getRegionChart(regionData)} theme='default' style={{ height: 400 }} />
              <div className='subjectToChange'>{i18n.t('subject to change')}</div>
            </div>
          </div>
        )}

        {countryData.length > 0 && (
          <div>
            <div className='chartHeader'>
              {i18n.t('COUNTRY EXPOSURE (% WEIGHT)')} {i18n.t('as of')} {this.asOfDate('countryExposures', countryData)}&nbsp;&nbsp;&nbsp;
              <span style={{ fontStyle: 'italic' }}>{i18n.t('select a country to view historical data')}</span>
            </div>
            <div className='chartContainer'>
              <ReactEcharts onEvents={{ click: this.props.setSelectedCountry }} option={getCountryChart(data)} style={{ height: getUniqueCountries(countryData).length * 40 + 150 }} />
            </div>
            <div id='country'>
              {this.props.selectedCountry !== '' && this.scrollCountry() && (
                <div className='subchartContainer'>
                  <RenderAggandExposureHistory />
                  <ReactEcharts option={getCountryGraph(selectedCountry, countryData)} theme='default' style={{ height: 300 }} />
                </div>
              )}
            </div>
            <div className='subjectToChange'> {i18n.t('subject to change')}</div>
          </div>
        )}

        {creditData.length > 0 && (
          <div>
            <div className='chartHeader'>
              {i18n.t('CREDIT PROFILE EXPOSURE (% WEIGHT)')} {i18n.t('as of')} {this.asOfDate('creditQualityExposures', creditData)}&nbsp;&nbsp;&nbsp;
              <span style={{ fontStyle: 'italic' }}></span>
            </div>
            <div className='chartContainer'>
              <ReactEcharts option={getCreditQualityChart(creditData)} theme='default' style={{ height: 400 }} />
              <div className='subjectToChange'>
                {i18n.t('subject to change')} {i18n.t('comp-cred-quality')}
              </div>
            </div>
          </div>
        )}

        {matureData.length > 0 && (
          <div>
            <div className='chartHeader'>
              {i18n.t('MATURITY PROFILE EXPOSURE (% WEIGHT)')} {i18n.t('as of')} {this.asOfDate('maturityExposures', matureData)}&nbsp;&nbsp;&nbsp;
              <span style={{ fontStyle: 'italic' }}></span>
            </div>
            <div className='chartContainer'>
              <ReactEcharts option={getMaturityChart(matureData)} theme='default' style={{ height: 400 }} />
              <div className='subjectToChange'>
                {i18n.t('subject to change')} {i18n.t('comp-bond')}
              </div>
            </div>
          </div>
        )}

        {assetData.length > 0 && (
          <div>
            <div className='chartHeader'>
              {i18n.t('ASSET CLASS EXPOSURE (% WEIGHT)')} {i18n.t('as of')} {this.asOfDate('assetClassExposures', assetData)}&nbsp;&nbsp;&nbsp;
              <span style={{ fontStyle: 'italic' }}></span>
            </div>
            <div className='chartContainer'>
              <ReactEcharts option={getAssetClassChart(assetData)} theme='default' style={{ height: 400 }} />
              <div className='subjectToChange'>{i18n.t('subject to change')}</div>
            </div>
          </div>
        )}

        {marketData.length > 0 && (
          <div>
            <div className='chartHeader'>
              {i18n.t('MARKET CAP EXPOSURE (% WEIGHT)')} {i18n.t('as of')} {this.asOfDate('marketCapExposures', marketData)}&nbsp;&nbsp;&nbsp;
              <span style={{ fontStyle: 'italic' }}></span>
            </div>
            <div className='chartContainer'>
              <ReactEcharts option={getMarketCapChart(marketData)} theme='default' style={{ height: 400 }} />
              <div className='subjectToChange'> {i18n.t('subject to change')}</div>
            </div>
          </div>
        )}

        {soeData.length > 0 && (
          <div>
            <div className='row' style={{ marginBottom: '20px' }}>
              <div className='col-md-3' style={{ textAlign: 'center', paddingRight: '3px' }}>
                <Select
                  options={[
                    { value: 'Country', label: 'Country' },
                    { value: 'Sector', label: 'Sector' }
                  ]}
                  styles={customStyles}
                  isMulti={false}
                  onChange={setActiveSoeDataType}
                  defaultValue={[{ value: 'Country', label: 'Country' }]}
                />
              </div>
            </div>
            <div className='row listoptions'>
              <div className={'col-md-12 col-sm-12 types'}>
                <button onClick={() => this.setActiveSoePane('Summary')} type='button' className={`navSoeButton ${activeSoePane === 'Summary' ? 'isselected' : 'notselected'}`}>
                  {i18n.t('Summary')}
                </button>
                <button onClick={() => this.setActiveSoePane('Details-SOE')} type='button' className={`navSoeButton ${activeSoePane === 'Details-SOE' ? 'isselected' : 'notselected'}`}>
                  {i18n.t('SOE')}
                </button>
                <button onClick={() => this.setActiveSoePane('Details-NonSOE')} type='button' className={`navSoeButton ${activeSoePane === 'Details-NonSOE' ? 'isselected' : 'notselected'}`}>
                  {i18n.t('non-SOE')}
                </button>
              </div>
              <br /> <br /> <br />
            </div>
            <div>
              <div className='table-responsive'>
                <table className='table tableFC'>
                  <thead>{this.renderSoeTableHeader()}</thead>
                  {this.renderSoeTableDetails()}
                </table>
              </div>
            </div>
            <br />
          </div>
        )}

        <CompText pane='Exposures' />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    data: state.fundData.data,
    selectedSector: state.params.selectedSector,
    selectedCountry: state.params.selectedCountry,
    scrollCountry: state.params.scrollCountry,
    activeSoeDataType: state.params.activeSoeDataType,
    activeSoePane: state.params.activeSoePane,
    loadingCatchAll: state.fundData.loadingCatchAll,
    errorCatchAll: state.fundData.errorCatchAll,
    hasBlendedData: state.fundData.hasBlendedData,
    aggReloadComplete: state.fundData.aggReloadComplete
  }
}

export default connect(mapStateToProps, {
  setSelectedSector,
  setSelectedCountry,
  resetScrollCountry,
  setActiveSoePane,
  setActiveSoeDataType
})(Exposures)